module.exports = __webpack_public_path__ + "img/add-note.01974a6c.svg";